<template>
    <div>
        <div>
            <h2 class="step__title">
                <VJoyIcon name="megaphone" />
                {{ $msg('customer.brief.exec.form.industry.expertise.tooltip.title') }}
            </h2>

            <p v-html="$msg('customer.brief.exec.form.mission.title.tooltip.content')"></p>
        </div>
    </div>
</template>

<script setup lang="ts"></script>

<style lang="scss" scoped>
    .joy-panel {
        display: flex;
        align-items: center;
        .left-icon {
            text-align: center;
            width: 160px;
        }
        .title {
            font-weight: 700;
        }
    }
</style>
